{
  "Addusertitle": "Anwendungsbenutzerkonto hinzufügen",
  "Modifyusertitle": "Anwendungsbenutzerkonto ändern",
  "PermissionsTitle": "Berechtigungen",
  "ExtensionTitle": "Erweiterung\/Endpunkt",
  "ReportingTitle": "Berichterstattung",
  "AdministratorTitle": "Administrator",
  "RoleTitle": "Rolle",
  "SettingsTitle": "Einstellungen",
  "ValidationWarning": "Bitte korrigieren Sie Fehler vor dem Abschluss",
  "ServerErrorTitle": "Validierungsfehler",
  "MonthlyBillingWarning": "WARNUNG: Beeinflusst die monatliche Abrechnung",
  "UnknownOrDeleted": "[Unbekannt oder gelöscht]",
  "AddUserLanguage_ButtonHelpLabel": "Hilfe?",
  "AddUserLanguage_ButtonSubmitLabel": "Speichern",
  "AddUserLanguage_ButtonCancelLabel": "Absagen",
  "AddUserLanguage_PromptMessage": "Möchten Sie dieses Fenster wirklich schließen? Alle geänderten Konfigurationen gehen beim Schließen verloren.",
  "AddUserLanguage_PromptConfirm": "Ja",
  "AddUserLanguage_PromptCancel": "Absagen",
  "AddUserLanguage_DetailsTitle": "Nutzerdetails",
  "NAME": "AddUserLanguage",
  "APIKeys_Title": "API-Schlüssel"
}